import { GiftOutline } from "react-ionicons";
import { useNavigate } from "react-router-dom";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import { THEME_COLORS } from "../themes/DarkLight";
import piNetworkAdsManager from "../utils/PiNetworkAdsManager";
import CommonButton from "./CommonButton";

export default function EasterEggModal({
  closeModal,
  userData,
}: {
  closeModal: any;
  userData: any;
}) {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  const navigate = useNavigate();

  const watchMoreAds = () => {
    closeModal();
    piNetworkAdsManager.handleRewardedAdFlowFront(userData?.user?.id);
  };

  return (
    <div onClick={closeModal} className="overlay">
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: THEME_COLORS[theme].full_theme }}
        className="ModalBottomSheet"
      >
        <>
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
            className=""
          >
            <div
              style={{
                backgroundColor: THEME_COLORS[theme].less_theme,
                marginBottom: "20px",
              }}
              className="bottomStyling"
            >
              {" "}
            </div>
          </div>

          {/* Reward Icon Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <GiftOutline height={"120px"} color={THEME_COLORS[theme].gold} />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "0",
              width: "100%",
            }}
          >
            <p
              style={{
                textAlign: "center",
                fontWeight: "500",
                fontSize: "25px",
                color: THEME_COLORS[theme].inverse_theme,
              }}
            >
              {
                "Congratulations !! You got rewarded with 0.000001Pi !! Watch more Ads and deposit more Pi to earn more rewards."
              }
            </p>
          </div>
          <p style={{ padding: "10px" }}>
            Want More Rewards ? Check Arthereum Wallet everyday to get more
            rewards.
          </p>
          <div style={{ height: "10px" }}></div>
          <CommonButton onClickHandle={watchMoreAds} text={"Watch More Ads"} />
          <div style={{ height: "10px" }}></div>
        </>
      </div>
    </div>
  );
}
